<template>
  <div class="comp-horizontal-navigation mb-3">
    <div
      class="nav-row"
      v-for="(row, rowIndex) in chunkedOptions"
      :key="'nav_row_' + rowIndex"
    >
      <SprButton
        v-for="(o, k) in row"
        :key="'nav_button_' + o.text + '_option_' + rowIndex + '_' + k"
        type="primary"
        :size="o.size || 4"
        :title="o.text"
        class="nav-item"
        :class="{ active: o.uri ? isActive(o.uri) : false }"
        :disabled="o.disabled"
        :click-event="'navigateTo' + rowIndex + '_' + k"
        v-on:[`navigateTo${rowIndex}_${k}`]="
          () => (o.action ? o.action() : o.uri ? navigate(o.uri) : null)
        "
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import SprButton from '../SPRButton.vue'

interface AdminNavOption {
  text: string
  uri?: string
  type?: string
  size?: number
  primary?: string
  disabled?: boolean
  action?: () => void
}

export default Vue.extend({
  name: 'AdminHorizontalNavigation',
  components: { SprButton },
  props: {
    options: {
      type: Array as () => AdminNavOption[],
      default: () => [] as AdminNavOption[],
    },
  },
  computed: {
    // Break options into sub-arrays of max length 3 for row rendering
    chunkedOptions(): AdminNavOption[][] {
      const out: AdminNavOption[][] = []
      for (let i = 0; i < this.options.length; i += 3) {
        out.push(this.options.slice(i, i + 3))
      }
      return out
    },
  },
  methods: {
    navigate(uri: string) {
      // only push if not already on that route
      if (this.$route.path !== uri) {
        this.$router.push(uri)
      }
    },
    isActive(uri: string) {
      // check if this button corresponds to the current route
      return this.$route.path === uri
    },
  },
})
</script>

<style lang="scss">
@import '~@/assets/scss/_variables.scss';
.comp-horizontal-navigation {
  .nav-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 0.5rem;
    row-gap: 0.5rem;
    margin-bottom: 0.75rem;
    &:last-child {
      margin-bottom: 0; // no extra space after final row
    }
  }
  .nav-item {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $brand-red;
    color: $brand-white;
  }
  .opt {
    display: inline-block;
    padding: 10px;

    font-size: 18px;
    text-decoration: none;

    font-family: 'Signa-Bold', Sans-Serif;

    color: $brand-grey10;

    transition: color 0.33s;

    &:hover {
      color: $brand-black;
      transition: color 0.33s;
    }
  }
  .margin-bottom-5 {
    // No longer used; spacing handled by flex gap.
    margin-bottom: 0;
  }

  .router-link-active {
    color: $brand-red !important;
    border-bottom: 2px solid $brand-red;
  }
}
</style>
